module.exports = __webpack_public_path__ + "static/media/reward.ba758fa7.png";